import clsx from "clsx";
import { FunctionComponent } from "react";

import HamburgerIcon from "@ui/components/icon/HamburgerIcon";
import { useNavigationContext } from "@ui/context/navigation-context";
import { sharedStyles } from "@ui/shared-styles";
import { useAnalytics } from "@voxmedia/duet-context/context/analytics-context";

import * as styles from "./HamburgerButton.css";

interface Props {
  monochrome?: boolean;
}

const HamburgerButton: FunctionComponent<Props> = ({ monochrome }) => {
  const analytics = useAnalytics();
  const { openDrawer, drawerId } = useNavigationContext();
  const handleMoreBtnClick = () => {
    openDrawer();
    analytics?.emit({
      event: "navigation_click",
      navigation_click: { name: "more button" },
    });
  };
  return (
    <button
      onClick={handleMoreBtnClick}
      className={styles.moreButton}
      aria-controls={drawerId}
      aria-label="Open Drawer"
    >
      <span className={sharedStyles.accessibility.srOnly}>Menu</span>
      <span
        className={clsx(
          monochrome && styles.monochrome,
          styles.moreIconContainer,
        )}
      >
        <HamburgerIcon className={styles.moreIcon} />
      </span>
    </button>
  );
};

export default HamburgerButton;
